import { toast } from "react-toastify";

export const handleError = (error) => {
  // If the error is a simple string, display it directly
  if (typeof error === "string") {
    toast.error(error);
    return;
  }
  if (error.response) {
    // Handle error object with a response property (likely an API error)
    const { data } = error.response;

    if (typeof data.message === "string") {
      // Single string message from API
      toast.error(data.message);
    } else if (Array.isArray(data.message)) {
      // Array of messages from API - combine into single message with new lines
      const combinedMessage = data.message
        .map((err) => err.error)
        .filter(Boolean)
        .join("\n");

      toast.error(combinedMessage);
    }
  } else if (error?.message) {
    toast.error(error.message);
  }
};

export const handleSuccess = (message) => {
  toast.success(message);
}